import React from 'react';

// eslint-disable-next-line react/prop-types
const LeftChevron = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>D951718D-EC41-4468-BB58-4116D146E6B5</title>
    <desc>Created with sketchtool.</desc>
    <g
      id="Final-design--(Web)"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Upload-documents-(With-data)"
        transform="translate(-356.000000, -48.000000)"
        fillRule="nonzero"
      >
        <g id="back-to-dashboard" transform="translate(356.000000, 48.000000)">
          <g id="Group">
            <path
              d="M11.99982,0 C5.3832,0 0,5.3832 0,12 C0,18.6168 5.3832,24 11.99982,24 C18.61674,24 24,18.6168 24,12 C24,5.3832 18.61674,0 11.99982,0 Z"
              id="Shape"
              fill="var(--PRIMARY)"
            />
            <path
              d="M14.49354,6.59106 C14.18616,6.28362 13.68774,6.28362 13.38072,6.59106 L8.52822,11.44344 C8.38062,11.59098 8.29764,11.7912 8.29764,11.99982 C8.29764,12.2085 8.38062,12.4086 8.52822,12.55614 L13.38072,17.40864 C13.53444,17.56236 13.7358,17.63928 13.9371,17.63928 C14.13834,17.63928 14.34024,17.56242 14.49342,17.40864 C14.8008,17.1015 14.8008,16.60308 14.49342,16.29594 L10.1976,11.9997 L14.49342,7.7037 C14.80092,7.39662 14.80092,6.89826 14.49354,6.59106 Z"
              id="Path"
              fill="#FFFFFF"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default LeftChevron;
